import React, {Component} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import SortBy from "@irati/ui/src/SortBy"
import {EVERYTHING, SORT_OPTIONS} from "@irati/recognition/constants/feedVisibility"
import {injectIntl} from "@irati/utils/lang"

const FlexWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

class Visibility extends Component {
  static propTypes = {
    initialValue: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }

  static defaultProps = {
    initialValue: EVERYTHING
  }

  constructor(props) {
    super(props)
    this.state = {
      value: props.initialValue,
      options: SORT_OPTIONS
    }
  }

  handleChange = ({value}) => {
    const {value: prevValue} = this.state
    this.setState({
      value
    })

    if (value !== prevValue) {
      this.props.onChange(value)
    }
  }

  render() {
    return (
      <FlexWrapper>
        <SortBy id="myTeams" options={this.state.options} defaultValue={EVERYTHING} value={this.state.value} onClick={this.handleChange} />
      </FlexWrapper>
    )
  }
}

export default injectIntl(Visibility)
